import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import AmenityForm from "./components/AmenityForm";
import { AmenityFormData } from "./utils/amenitySchema";
import { useAmenity } from "@/components/pages/amenities/hooks/amenities.hooks";
import { useTranslation } from "react-i18next";

const noop = async () => {};

const ViewAmenityPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: amenity, isLoading } = useAmenity(id || "");
  const { t } = useTranslation();

  const initialValues: Partial<AmenityFormData> | undefined = useMemo(() => {
    if (!amenity) return undefined;
    return {
      name: amenity.name,
      description: amenity.description,
      category: amenity.category,
      isActive: amenity.isActive,
      photoId: amenity.photoId ?? undefined,
      serviceIds: amenity.services?.map((service) => service.id) ?? [],
      schedules: amenity.schedules?.map((s) => ({
        days: s.days,
        startTime: s.startTime,
        endTime: s.endTime,
      })) || [{ days: [], startTime: "", endTime: "" }],
    };
  }, [amenity]);

  if (isLoading || !initialValues) {
    return <div className="p-12">{t("amenities.loading.loading")}</div>;
  }

  return (
    <div className="mx-auto max-w-[960px] p-12">
      <AmenityForm
        titleText={t("amenities.form.viewTitle", "View Amenity")}
        onSubmit={noop}
        initialValues={initialValues}
        readOnly
      />
    </div>
  );
};

export default ViewAmenityPage;
